export default __webpack_public_path__ + "config_panel_logo.d73b5d0d.png";